import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_QUEUE_DEPTH_ACTION_TYPE = createNamedActions(
  'commandCenterQueueDepth',
  {
    SET_QUEUE_DEPTH: 'SET_QUEUE_DEPTH',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterQueueDepthAction = catchAsyncActionError(() => async dispatch => {
  try {
    const data = await fetchSafe(() =>
      commandCenterLoansApi.getQueueDepth({ config: SKIP_FORBIDDEN_CONFIG }),
    );

    dispatch({
      type: COMMAND_CENTER_QUEUE_DEPTH_ACTION_TYPE.SET_QUEUE_DEPTH,
      payload: data,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403/404
    // degrades to null — otherwise the zone skeleton never clears (DEV-4175).
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.QUEUE_DEPTH));
  }
});
